import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { deleteAdminTabledata } from "../../axios";
import { useDispatch } from "react-redux";
import loader from "../../loader.gif";
import "./index.css";

function DeleteAdminModal({
  isModalOpen,
  setIsModalOpen,
  selectedDeleteItem,
  refetchApi,
  response,
  setResponse,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // console.log(response, "responseresponse", loading);
  // console.log(selectedDeleteItem, "selectedDeleteItem");

  const handleOnDelete = () => {
    let payload = {
      id: selectedDeleteItem?.id || selectedDeleteItem?.Id,
      url: selectedDeleteItem?.url,
    };
    setLoading(true);
    dispatch(deleteAdminTabledata(payload))
      .then((result) => {
        // console.log(result, "resulyyyt", setIsModalOpen);
        // setResponse({ ...result });
        setIsModalOpen(false);
        // setLoading(false);
        refetchApi();
      })
      .catch((err) => {
        setLoading(false);
        setResponse(err?.response);
      });
  };

  useEffect(() => {
    return () => {
      setLoading(false);
      // setResponse("");
    };
  }, []);

  const RenderDeleteMsg = () => {
    return (
      <div className="deleteWanringMsg">
        <p>
          <span>Are you sure </span> you want to delete{" "}
          {selectedDeleteItem?.[selectedDeleteItem?.deleteItemName]} <b></b>{" "}
        </p>
        <p>You can't undo this action.</p>
      </div>
    );
  };

  const RenderLoading = () => {
    return (
      <>
        <div className="fixedLoader">
          <img src={loader} className="loaderr" />
        </div>
      </>
    );
  };

  const RenderResponse = () => {
    return (
      <>
        {response?.status === 200 ? (
          <div ClassName="failedMsg">
            <div className="successMsg">
              <i className="now-ui-icons ui-1_check"></i>&nbsp; Success
            </div>
            <div className="successTxt"> Deleted Successfully</div>
          </div>
        ) : (
          <div>
            <div ClassName="failedMsg">
              <div className="failed">
                <i className="now-ui-icons ui-1_simple-remove"></i>&nbsp; Failed
              </div>
              <div className="failedTxt">
                {response?.data?.responseDesc &&
                typeof response?.data?.responseDesc === "string"
                  ? response?.data?.responseDesc
                  : "Delete Failed"}
              </div>
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <Modal
      title={<h3>Delete {selectedDeleteItem?.deleteTitle}</h3>}
      visible={isModalOpen}
      onCancel={() => {
        setIsModalOpen(false);
        setLoading(false);
        setResponse("");
      }}
      onOk={() => {
        if (response) {
          setIsModalOpen(false);
          setLoading(false);
          setResponse("");
        } else {
          handleOnDelete();
        }
      }}
      okText={response ? "OK" : "Delete"}
      destroyOnClose
      width={800}
      confirmLoading={loading}
      // size={"large"}
    >
      {response ? <RenderResponse /> : <RenderDeleteMsg />}
      {/* <RenderResponse /> */}
    </Modal>
  );
}

export default DeleteAdminModal;
